var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalenom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 16,
    viewBox: "0 0 101 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2502_150827)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2502_150827",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.772949 0.503906H100.569V15.5039H0.772949V0.503906Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2502_150827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.772949 3.0937V0.751865H11.178V3.0937H7.2658V15.21H4.67907V3.0937H0.772949ZM17.9311 4.29982L15.5311 10.1927H20.3311L17.9311 4.29982ZM19.0239 0.748804L25.0423 15.2161H22.3178L21.1362 12.3355H14.7199L13.5382 15.2161H10.8076L16.826 0.751865H19.0239V0.748804ZM30.2494 0.748804V12.8712H35.977V15.21H27.6627V0.748804H30.2494ZM53.5484 0.748804L61.1861 10.7927V0.751865H63.6902V15.2161H61.581L53.7841 4.98859V15.2161H51.2831V0.751865H53.5545L53.5484 0.748804ZM74.2698 13.1621C77.1443 13.1621 79.3361 10.9243 79.3361 8.01308C79.3361 5.12941 77.1443 2.84574 74.2698 2.84574C71.3953 2.84574 69.2035 5.11104 69.2035 8.01308C69.1943 10.9427 71.3892 13.1621 74.2698 13.1621ZM74.2698 0.503906C78.5096 0.503906 81.9045 3.76411 81.9045 8.01308C81.9045 12.2621 78.5127 15.5039 74.2729 15.5039C70.0484 15.5039 66.6596 12.2621 66.6596 8.01308C66.6565 3.76411 70.0484 0.503906 74.2729 0.503906H74.2698ZM87.9718 0.748804L92.129 11.1263L96.3075 0.748804H98.3371L100.569 15.2192H98.083L96.6749 5.98655L93.0565 15.2192H91.2137L87.5953 5.96819L86.1871 15.2192H83.7014L85.9361 0.751865H87.9718V0.748804ZM41.3647 12.8712L39.4484 9.80389L38.7749 10.2263V15.21H48.1086V12.8712H41.3617H41.3647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.855 11.1172L47.5367 7.53868L47.9867 5.87338L46.2999 5.55501L42.5867 7.89072L41.3622 5.92848V3.09379H47.9591V0.751953H38.7755V5.84889L33.7397 9.02337L34.9795 11.0009L39.8622 7.93052L41.855 11.1172Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2502_150827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.7958,
    height: 15,
    fill: "white",
    transform: "translate(0.770996 0.501953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalenom);
export default __webpack_public_path__ + "static/media/talenom.06b0b246dc54420f2c5983c882639ca4.svg";
export { ForwardRef as ReactComponent };